import { Outlet, Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { jwtDecode } from "jwt-decode";
import { TokenPayload } from "../types/ComponentProps";
import { NotificationProvider } from "../context/NotificationContext";

/**
 * Route guard that allows access to admin users AND specific user IDs
 * defined in the REACT_APP_COIN_GIVER_IDS environment variable.
 *
 * Usage in .env:
 *   REACT_APP_COIN_GIVER_IDS=3,5,12,45
 */
const CoinGiverRoute = () => {
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const accessToken = localStorage.getItem("accessTokenGC");

  if (!isAuthenticated || !accessToken) {
    return <Navigate to="/login" />;
  }

  try {
    const userDetails: TokenPayload = jwtDecode<TokenPayload>(accessToken);

    // Admins always have access
    if (userDetails?.isAdmin) {
      return (
        <NotificationProvider>
          <Outlet />
        </NotificationProvider>
      );
    }

    // Check if user ID is in the allowed coin giver list
    const allowedIds = (process.env.REACT_APP_COIN_GIVER_IDS || "")
      .split(",")
      .map((id) => Number(id.trim()))
      .filter((id) => !isNaN(id) && id > 0);

    if (userDetails?.id && allowedIds.includes(userDetails.id)) {
      return (
        <NotificationProvider>
          <Outlet />
        </NotificationProvider>
      );
    }

    // Not authorized — redirect to home
    return <Navigate to="/" />;
  } catch (error) {
    console.error("Error decoding token:", error);
    return <Navigate to="/login" />;
  }
};

export default CoinGiverRoute;
